import { showNotification } from 'shared/common/AppNotification/ui'
import { CheckboxOptions } from 'shared/common/ConvertToCheckboxOptions'
import { useFilter } from 'shared/common/OpenFiltersButton/hooks/useFilter'
import { ParamKey } from 'shared/types/QueryModel'

import { useEffect, useState } from 'react'

import { SelectQuery } from 'shared/ui/FormQuery/SelectQuery'
import { Spin } from 'shared/ui/Spin'

import { useBrandBranch } from '../hooks/useBrandBranch'

interface Props {
  queryKeys?: ParamKey[]
}

const selectClass = 'w-full min-h-[36px]'
const BrandBranchFilter = ({ queryKeys = ['company', 'branch'] }: Props) => {
  const { filters, setFilters } = useFilter()
  const { isFetchingBranches, isFetchingBrands, branchOptions, brandOptions } =
    useBrandBranch({ queryKeys })

  const [isOpenBranch, setIsOpenBranch] = useState<boolean>(false)

  const handleClickBranchSelect = (isOpen: boolean) => {
    if (!filters?.[queryKeys[0]]) {
      showNotification({
        type: 'error',
        message: 'Выберите бренд перед филиалом',
      })
      setIsOpenBranch(false)
    } else {
      setIsOpenBranch(isOpen)
    }
  }

  useEffect(() => {
    if (!filters?.[queryKeys[0]]) {
      setFilters([{ [queryKeys[1]]: '' }])
    }
  }, [filters?.[queryKeys[0]]])

  return (
    <>
      <SelectQuery
        notFoundContent={isFetchingBrands ? <Spin size="small" /> : null}
        placeholder="Бренд"
        className={selectClass}
        options={CheckboxOptions({
          options: brandOptions,
          paramKey: queryKeys[0],
        })}
        queryKey={queryKeys[0]}
      />
      <SelectQuery
        notFoundContent={isFetchingBranches ? <Spin size="small" /> : undefined}
        placeholder="Филиал"
        className={selectClass}
        onDropdownVisibleChange={handleClickBranchSelect}
        options={CheckboxOptions({
          options: branchOptions,
          paramKey: queryKeys[1],
        })}
        queryKey={queryKeys[1]}
        open={isOpenBranch}
      />
    </>
  )
}

export default BrandBranchFilter
